import { reqLogout } from "../../api"
import { useHistory } from "react-router-dom"
import "./header.less"
import { useState, useEffect } from "react"
import { Modal, Avatar, Space } from "antd"
import { ExclamationCircleOutlined, UserOutlined } from "@ant-design/icons"
import LinkButton from "../link-button"
import store from "../../utils/storeUtils"
import img from "../../assets/images/avatar01.png"
import cookie from 'react-cookies'
const { confirm } = Modal
const handleClick = async (history) => {
    //登出
    confirm({
        title: '确定要退出吗?',
        icon: <ExclamationCircleOutlined />,
        async onOk() {
            const res = await reqLogout()
            if (res.data.result === 1) {
                store.clear()
                cookie.remove('.SCAUTH', { path: '/' })
                history.replace("/login")
            }

        },
        onCancel() {

        },
    });
}


const Header = props => {
    const history = useHistory()
    const [currentTime, changeTime] = useState(new Date().toLocaleString())
    const [title, setTitle] = useState("")
    useEffect(() => {
        const id = setInterval(() => {
            changeTime(new Date().toLocaleString())
        }, 1000);
        return () => {
            clearInterval(id)
        }
    }, [])
    return (

        <div className="header">
            {/* <div className="header-top"> */}
            <span>欢迎，</span>
            <Avatar style={{ marginTop: -5, backgroundColor: '#A6DBFF', }} size="small" src={img} />
            <span className="company-name">{store.getCompanyInfo()?.company_name}</span>
            <LinkButton href="#top" onClick={() => { handleClick(history) }}>
                退出
            </LinkButton>

            {/* </div> */}
            {/* <div className="header-bottom">
                <div className="header-bottom-left">{title}</div>
                <div className="header-bottom-right">
                    <span>{currentTime}</span>
                </div>
            </div> */}
        </div>
    )
}

export default Header